import { Link as RouterLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Box, Button, Typography } from "@mui/material";

import BrandLogo from "../shell/BrandLogo";

/**
 * Shown for any address CSI Pay doesn't know (AB#6872, AC1): the Care Solutions logo,
 * a plain message and a way back to the dashboard. Theme tokens only, so it follows
 * Light / Dark / Auto.
 */
function Page404() {
  return (
    <Box
      component="main"
      sx={{
        flex: 1,
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 4,
        px: 5,
        py: { xs: 8, md: 10 },
        textAlign: "center",
        bgcolor: "background.default",
        color: "text.primary",
      }}
    >
      <Helmet title="404 Error" />
      <BrandLogo height={46} />
      <Box sx={{ display: "grid", gap: 2, maxWidth: 400 }}>
        <Typography
          variant="h2"
          component="h1"
          sx={{ fontSize: "1.3125rem", fontWeight: 500 }}
        >
          Page not found
        </Typography>
        <Typography sx={{ fontSize: "0.875rem", color: "text.secondary" }}>
          The page you were looking for doesn't exist or has moved.
        </Typography>
      </Box>
      <Button component={RouterLink} to="/" variant="contained" color="primary">
        Go to the dashboard
      </Button>
    </Box>
  );
}

export default Page404;
